export default __webpack_public_path__ + "static/media/blueNotification.c6302f92.jpg";